import { compare, validate } from 'compare-versions';

const ARTIFACT_TYPE_REGEX = {
  FRIDGE_UI_APPLICATION: /^[0-9.]*$/,
  FRIDGE_JAVA_SERVER: /^[0-9.]*$/,
  FRIDGE_AGENT: /^[0-9.]*$/,
  FRIDGE_INVENTORY: /^[0-9.]*$/,
  FRIDGE_PRICING_PARSER: /^[0-9.]*$/,
  FRIDGE_PRICING_CONSUMER: /^[0-9.]*$/,
  FRIDGE_HEARTBEAT: /^[0-9\s]+$/,
};

// Get cleaned up version name, TO BE MODIFIED as more versions added
export const cleanVersion = (artifactType, rawName) => {
  // Special Cases
  if (artifactType === 'FRIDGE_JAVA_SERVER_CONFIG') {
    return 'True';
  }

  let chunks;
  let withVersion;

  // Include a unique portion before and after the version string
  const boundariesOfVersions = {
    FRIDGE_UI_APPLICATION: ['farmers-fridge-react-', '.AppImage'],
    FRIDGE_JAVA_SERVER: ['kiosk-node-', '-SNAPSHOT.jar'],
    FRIDGE_AGENT: ['v', '/fridge-agent'],
    FRIDGE_PRICING_PARSER: ['v', '/pricing-parser'],
    FRIDGE_PRICING_CONSUMER: ['v', '/pricing-consumer'],
    FRIDGE_INVENTORY: ['v', '/fridge-inventory'],
    FRIDGE_HEARTBEAT: [null, '/fridgeheartbeat'],
  };

  if (artifactType in boundariesOfVersions) {
    const before = boundariesOfVersions[artifactType][0];
    const after = boundariesOfVersions[artifactType][1];

    withVersion = rawName.split(after)[0];
    chunks = withVersion.split(before);
    return chunks[chunks.length - 1];
  }
  return rawName;
};

export const getFilterDescription = (response) => {
  const isVersions = response.selectedVersions.length;
  const isPilot = Object.keys(response.selectedPilot).length;
  const description = ['FILTER • ('];

  // Build string

  // Check for statuses
  Object.keys(response.statuses).map((key) => {
    if (response.statuses[key]) {
      description.push(key);
      description.push(', ');
    }
  });

  if (description.length > 1) {
    description.pop();
  }

  // Check for versions
  if (isVersions) {
    if (description.length > 1) {
      description.push(' | ');
    }

    description.push(response.selectedSoftware.artifactType);
    description.push(' = ');
    response.selectedVersions.map((version) => {
      description.push(version.cleanName);
      description.push(', ');
    });
    description.pop();
  }

  // Check for pilots
  if (isPilot) {
    if (description.length > 1) {
      description.push(' | ');
    }

    description.push('Pilot: ');
    description.push(response.selectedPilot.displayName);
  }

  description.push(') SELECTED');
  return description.join('');
};

// Check for scan filters
export const noVersionCheck = (artifactType, tableData) => {
  const entries = {};
  Object.keys(tableData).map((key) => {
    // eslint-disable-next-line no-prototype-builtins
    if (!tableData[key].hasOwnProperty(artifactType)) {
      entries[key] = tableData[key];
    }
  });
  return entries;
};

export const sortArrayOfObjects = (arr, key, order) => {
  return arr.sort((a, b) => {
    if (order === 'asc') {
      if (!(key in b)) return 1;
      if (!(key in a)) return -1;
      if (validate(a[key]) && validate(b[key])) {
        const comparison = compare(a[key], b[key], '>');
        return comparison ? 1 : -1;
      }
      // The entries are not versions (e.g. booleans)
      return a[key] > b[key] ? 1 : -1;
    }
    if (!(key in a)) return 1;
    if (!(key in b)) return -1;
    if (validate(a[key]) && validate(b[key])) {
      const comparison = compare(a[key], b[key], '<');
      return comparison ? 1 : -1;
    }
    return a[key] < b[key] ? 1 : -1;
  });
};

export const sortOnPilots = (arr, order, pilotsData) => {
  // Get all fridge Ids to dict
  const dictPilotData = {};
  pilotsData.map((pilot) => {
    pilot.fridgeIds.map((id) => {
      dictPilotData[id] = pilot;
    });
  });

  return arr.sort((a, b) => {
    if (order === 'asc') {
      if (!(b.fridgeName in dictPilotData)) return 1;
      if (!(a.fridgeName in dictPilotData)) return -1;
      return dictPilotData[a.fridgeName].displayName >
        dictPilotData[b.fridgeName].displayName
        ? 1
        : -1;
    }
    if (!(a.fridgeName in dictPilotData)) return 1;
    if (!(b.fridgeName in dictPilotData)) return -1;
    return dictPilotData[a.fridgeName].displayName <
      dictPilotData[b.fridgeName].displayName
      ? 1
      : -1;
  });
};

export const dateToString = (date) => {
  const monthDict = {
    '01': 'Jan.',
    '02': 'Feb.',
    '03': 'Mar.',
    '04': 'Apr.',
    '05': 'May',
    '06': 'Jun.',
    '07': 'Jul.',
    '08': 'Aug.',
    '09': 'Sep.',
    10: 'Oct.',
    11: 'Nov.',
    12: 'Dec.',
  };

  const stringVersion = [];

  stringVersion.push(`${monthDict[date.substring(5, 7)]} `);
  stringVersion.push(`${date.substring(8, 10)}, `);
  stringVersion.push(date.substring(0, 4));

  return stringVersion.join('');
};

export const getFilteredData = (tableData, filterResponse) => {
  const filteredEntries = {};

  const isPilot = Object.keys(filterResponse.selectedPilot).length;
  const isVersions = filterResponse.selectedVersions.length;

  // Handle artifact versions with pilots
  if (isPilot && isVersions) {
    // First get all fridges in pilot
    const entriesInPilot = {};
    filterResponse.selectedPilot.fridgeIds.map((id) => {
      if (id in tableData) {
        entriesInPilot[id] = tableData[id];
      }
    });

    // Retrieve fridges in entriesInPilot that also match version
    filterResponse.selectedVersions.map((version) => {
      if (version.cleanName === 'No Version') {
        const noVersions = noVersionCheck(
          filterResponse.selectedSoftware.artifactType,
          entriesInPilot,
        );
        Object.keys(noVersions).map((locationName) => {
          filteredEntries[locationName] = noVersions[locationName];
        });
      } else {
        version.fridgesDeployedTo.map((fridgeName) => {
          if (fridgeName in entriesInPilot) {
            filteredEntries[fridgeName] = entriesInPilot[fridgeName];
          }
        });
      }
    });
  }

  // Handle pilots no artifact versions
  else if (isPilot) {
    filterResponse.selectedPilot.fridgeIds.map((id) => {
      if (id in tableData) {
        filteredEntries[id] = tableData[id];
      }
    });
  }

  // Handle artifact versions no pilots
  else if (isVersions) {
    filterResponse.selectedVersions.map((version) => {
      if (version.cleanName === 'No Version') {
        const noVersions = noVersionCheck(
          filterResponse.selectedSoftware.artifactType,
          tableData,
        );
        Object.keys(noVersions).map((locationName) => {
          filteredEntries[locationName] = noVersions[locationName];
        });
      } else {
        version.fridgesDeployedTo.map((fridgeName) => {
          if (fridgeName in tableData) {
            filteredEntries[fridgeName] = tableData[fridgeName];
          }
        });
      }
    });
  }

  // Neither versions or pilot selected
  else {
    Object.keys(tableData).map((entry) => {
      filteredEntries[entry] = tableData[entry];
    });
  }

  // Handle fridge statuses
  // Iterate through statuses
  const selectedStatuses = new Set();
  Object.keys(filterResponse.statuses).map((status) => {
    if (filterResponse.statuses[status]) {
      selectedStatuses.add(status);
    }
  });

  if (selectedStatuses.size > 0) {
    Object.keys(filteredEntries).map((key) => {
      const currEntry = filteredEntries[key];
      if (!selectedStatuses.has(currEntry.status)) {
        delete filteredEntries[key];
      }
    });
  }
  return filteredEntries;
};

export const isCorrectAWSDate = (date) => {
  if (date.length !== 10) {
    return false;
  }

  const year = date.substring(0, 4);
  const month = date.substring(5, 7);
  const day = date.substring(8, 10);

  if (
    /^[0-9]+$/.test(year) &&
    date.charAt(4) === '-' &&
    /^[0-9]+$/.test(month) &&
    date.charAt(7) === '-' &&
    /^[0-9]+$/.test(day)
  ) {
    return true;
  }

  return false;
};

export const getDeployableVersions = (artifactType, allVersions) => {
  const deployableVersions = [];
  allVersions.map((version) => {
    if (ARTIFACT_TYPE_REGEX[artifactType].test(version.cleanVersion)) {
      deployableVersions.push(version);
    }
  });

  return deployableVersions;
};
